// react-query를 사용하는 root 모델들이 extends하는 모델들입니다.
export * from './query-list-model';
export * from './query-model';
